import React from 'react';
import {
  List,
  Datagrid,
  TextField,
} from 'react-admin';
import {
  Button
} from '@material-ui/core';

const AddtitionalActions: React.FC = (props: any) => {
  return (
    <div>
    <Button
      variant='contained'
      color='primary'
      size='medium'
    >
      Отправить посл. версию на переподпись
    </Button>
    </div>
  );
}

const AgreementsList: React.FC = (props: any) => {
  return (
    <List
      {...props}
      actions={<AddtitionalActions/>}
      bulkActionButtons={false}
    >
      <Datagrid
        rowClick='edit'
      >
        <TextField source='agreementUserId'/>
        <TextField source='agreementUserUpdatedAt'/>
        <TextField source='agreementUserUpdatedBy'/>
        <TextField source='agreementPrivacyId'/>
        <TextField source='agreementPrivacyUpdatedAt'/>
        <TextField source='agreementPrivacyUpdatedBy'/>
      </Datagrid>
    </List>
  );
};

export default AgreementsList;